import { createContext, useContext, useState } from 'react';

export type AccountTypes = 'demo' | 'volvoid';
export type AuthorizedStates = AccountTypes | undefined;

type SwaggerState = {
  accountType: AccountTypes;
  setAccountType: (type: AccountTypes) => void;
  authorizedState: AuthorizedStates;
  setAuthorizedState: (accountType: AuthorizedStates) => void;
};

const TryItOutContext = createContext<SwaggerState>({} as SwaggerState);

export const useTryItOut = () => useContext(TryItOutContext);

const TryItOutProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const [authorizedState, setAuthorizedState] =
    useState<AuthorizedStates>(undefined);
  const [accountType, setAccountType] = useState<AccountTypes>('demo');

  const state: SwaggerState = {
    accountType,
    setAccountType,
    authorizedState,
    setAuthorizedState,
  };

  return (
    <TryItOutContext.Provider value={state}>
      {children}
    </TryItOutContext.Provider>
  );
};

export default TryItOutProvider;
